import React, { useMemo, useState, useRef } from 'react';
import { addMilliseconds, isWithinInterval, subMilliseconds } from 'date-fns';
import { Button } from 'app/components';
import LabelField from '../../components/labelField/LabelField';
import { ATTENDEE_DETAILS } from './constants';
import { CheckCircle } from '@phosphor-icons/react';
import CheckInModal from './checkInModal';
import CheckInModal2 from './checkInModal2';
import { checkIn } from '../../api';
import { TIME_INTERVAL_CONFIG } from '../../../../constants/timeIntervalConfig';
import './style';


const AttendeeView = (props) => {
  const {
    id,
    setId,
    config,
    eventDetails,
    resourceMapping,
    ticketCount,
    setSelectedAttendee,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [checkInCount, setCheckInCount] = useState(1);
  const [lastCheckInCount, setLastCheckInCount] = useState(0);

  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [lastCheckInAttendees, setLastCheckInAttendees] = useState([])

  const total_quantity = config?.ticket_details[0]?.quantity;
  const timeoutRef = useRef(null);
  const modalRef = useRef(null);

  const eventQuestions = useMemo(() => {
    if (eventDetails?.get_to_know_details?.length) {
      const data = {};

      eventDetails.get_to_know_details.forEach((item) => {
        data[item?.id] = item;

        if (item?.conditions?.length) {
          item?.conditions?.forEach((choice) => {
            data[choice?.config?.id] = choice?.config;
          });
        }
      });

      return data;
    }

    return {};
  }, [eventDetails?.get_to_know_details]);

  const getAttendeeResponse = (questionConfig, id, value) => {
    if (Array.isArray(value)) {
      const options = questionConfig?.options?.reduce((obj, opt) => {
        return {
          ...obj,
          [opt?.id]: opt?.value,
        };
      }, {});

      if (value?.includes('internal-tmt-others')) {
        return value.map((val) => options?.[val]).concat(value[value.length - 1]).filter((item) => !!item).join(', ');
      }

      return value.map((val) => options?.[val]).filter((item) => !!item).join(', ');
    }

    if (questionConfig?.options?.length && questionConfig?.type !== 'Email') {
      return questionConfig.options.find((item) => item?.id === value)?.value;
    }

    return value;
  };

  const getPrimaryDetails = (key) => {
    switch (key) {
      case 'full_name':
        return config?.get_to_know_details?.details?.[0]?.full_name;
      case 'email':
        if (config?.get_to_know_details?.details?.[0]?.email) return config?.get_to_know_details?.details?.[0]?.email;
        else {
          const emailQ = eventDetails?.get_to_know_details?.find((item) => item?.type === 'Email');

          if (emailQ) return config?.get_to_know_details?.details?.[0]?.[emailQ?.id];
        }
      case 'phone number':
        return config?.get_to_know_details?.details?.[0]?.phone_number;
      case 'category':
        return config?.ticket_details?.[0]?.category;
      default:
        return config?.[key];
    }
  };

  const incrementCheckInCount = () => {
    if (checkInCount < total_quantity - ticketCount) {
      setCheckInCount((prev) => prev + 1);
    }
  };

  const decrementCheckInCount = () => {
    setCheckInCount((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleCheckIn = () => {
    setLastCheckInCount(checkInCount);
    setShowModal(false);
    setShowSuccessModal(true);

    timeoutRef.current = setTimeout(() => {
      const nonCheckedInList = resourceMapping?.filter((item) => !item?.is_checked_in) || [];
      const ids = nonCheckedInList.slice(0, checkInCount).map((item) => item?.resource_id);

      checkIn(config?.event_details?.id, {
        'bookingId': config?.id,
        'ticket_mapping': ids,
        'is_check_in': true,
      }, () => {
        setId(prev => prev + 1);
        setShowSuccessModal(false);
        setCheckInCount(1);
        setSelectedAttendee(null);
      })
    }, 3000);
  }

  const handleUndo = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setCheckInCount(lastCheckInCount);
    setLastCheckInCount(0);
    setShowSuccessModal(false);
    setShowModal(true);
  };

  const toggleSelectAttendee = (id) => {
    if (selectedAttendees.includes(id)) {
      setSelectedAttendees(selectedAttendees.filter((itemId) => itemId !== id));
    } else {
      setSelectedAttendees([...selectedAttendees, id]);
    }
  };

  const handleCheckIn2 = () => {
    ;
    setLastCheckInAttendees(selectedAttendees);
    setCheckInCount(selectedAttendees.length)
    setShowModal(false);
    setShowSuccessModal(true);

    timeoutRef.current = setTimeout(() => {
      const ids = selectedAttendees?.map((idx) => resourceMapping?.[idx]?.resource_id)

      checkIn(config?.event_details?.id, {
        'bookingId': config?.id,
        'ticket_mapping': ids,
        'is_check_in': true,
      }, () => {
        setId(prev => prev + 1);
        setShowSuccessModal(false);
        setSelectedAttendees([]);
        setSelectedAttendee(null);
        setCheckInCount(1)
      })
    }, 3000);
  };

  const handleUndo2 = () => {
    setSelectedAttendees(lastCheckInAttendees);
    setLastCheckInAttendees([]);
    setShowSuccessModal(false);
    setShowModal(true);
  };

  return (
    (window.innerWidth <= 768) ?
      (<>
        <div className="flex flex-col gap-6 pb-32 px-4 pt-4">

          {/* ATTENDEE DETAILS — SINGLE COLUMN */}
          <div className="flex flex-col gap-4">
            {ATTENDEE_DETAILS.map((data) => (
              <div key={data.key} className="flex flex-col gap-0.5">
                <span className="text-[11px] font-medium text-gray-500">
                  {data.label}
                </span>
                <span className="text-sm font-semibold text-gray-900">
                  {getPrimaryDetails(data.key)}
                </span>
              </div>
            ))}
          </div>

          {/* SCAN HISTORY */}
          <div>
            <h3 className="text-base font-semibold mb-2">Scan History</h3>

            <div className="flex flex-col gap-4">
              {resourceMapping?.map((resource, i) =>
                resource?.is_checked_in ? (
                  <div key={i} className="flex gap-3 items-start">

                    {/* Green ring */}
                    <div className="flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 mt-1">
                      <div className="w-2 h-2 rounded-full bg-green-600" />
                    </div>

                    <div>
                      <div className="text-sm font-medium">Scan in</div>
                      <div className="text-xs text-gray-500">
                        {new Date(resource?.last_modified_date).toLocaleTimeString(
                          "en-US",
                          { hour: "2-digit", minute: "2-digit", hour12: true }
                        )}
                      </div>
                    </div>

                  </div>
                ) : null
              )}
            </div>
          </div>

          {/* ATTENDEE BLOCKS */}
          {config?.get_to_know_details?.details?.map((attendee, index) => (
            <div key={index} className="flex flex-col gap-4">

              {config?.get_to_know_details?.details?.length > 1 && (
                <>
                  <div className="w-full h-px bg-gray-200" />

                  <div className="flex flex-col gap-1">
                    <div className="text-sm font-semibold">
                      Attendee {index + 1} – {attendee?.full_name}
                    </div>

                    {index === 0 && (
                      <div className="text-[10px] text-green-700 bg-green-100 px-2 py-1 rounded w-fit">
                        Purchased tickets
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* Q/A — SINGLE COLUMN */}
              <div className="flex flex-col gap-4">
                {Object.keys(attendee || {}).map((item) =>
                  eventQuestions?.[item]?.label &&
                    (index === 0 ? !eventQuestions?.[item]?.isPreset : true) ? (
                    <div key={item} className="flex flex-col gap-1">

                      <span className="text-[11px] font-medium text-gray-500 flex flex-wrap gap-1">
                        {eventQuestions?.[item]?.label} (
                        <span className="text-[11px]">{eventQuestions?.[item]?.type}</span>
                        )
                      </span>

                      <span className="text-sm font-medium text-gray-900 break-words">
                        {getAttendeeResponse(
                          eventQuestions?.[item],
                          item,
                          attendee?.[item]
                        )}
                      </span>

                    </div>
                  ) : null
                )}
              </div>
            </div>
          ))}
        </div>

        {/* FIXED BOTTOM CHECK-IN BAR */}
        <div
  className={`fixed left-0 bottom-0 w-full flex flex-col items-center gap-2.5 px-6 py-4 border-t border-gray-200 ${
    !showSuccessModal ? "bg-white" : "bg-green-50"
  }`}
>
  {showSuccessModal ? (
    <div className="relative flex items-center gap-2 p-4 w-full max-w-xs bg-green-50 rounded-lg">
      <CheckCircle size={20} fill="#009D64" weight="fill" />
      <h5 className="text-sm font-medium">
        {checkInCount} ticket{checkInCount > 1 ? "s" : ""} checked in!
      </h5>

      <button
        className="text-sm text-green-700 ml-auto underline"
        onClick={
          config?.get_to_know_details?.details?.length > 1
            ? handleUndo2
            : handleUndo
        }
      >
        Undo
      </button>
    </div>
  ) : (
    <div className="flex flex-col items-center w-full max-w-xs gap-2">

      {/* Centered Check-in button ALWAYS */}
      <button
        className="px-5 py-2 bg-green-600 text-white rounded-lg font-medium disabled:bg-gray-300 w-full text-center"
        disabled={
          ticketCount >= total_quantity ||
          !isWithinInterval(new Date(), {
            start: subMilliseconds(
              new Date(eventDetails?.start_date),
              TIME_INTERVAL_CONFIG.CHECKIN_START
            ),
            end: addMilliseconds(
              new Date(eventDetails?.end_date),
              TIME_INTERVAL_CONFIG.CHECKIN_END
            ),
          })
        }
        onClick={() => setShowModal(true)}
      >
        Check in
      </button>

      {/* Tickets checked in text BELOW button */}
      {ticketCount > 0 && (
        <div className="flex items-center gap-2 justify-center">
          <CheckCircle size={20} fill="#009D64" weight="fill" />
          <h5 className="text-sm font-medium">
            {ticketCount}/{total_quantity} tickets checked in!
          </h5>
        </div>
      )}

    </div>
  )}
</div>

        {/* MODALS */}
        {config?.get_to_know_details?.details?.length > 1 ? (
          <CheckInModal2
            isOpen={showModal}
            config={config}
            eventQuestions={eventQuestions}
            attendeeDetails={config?.get_to_know_details?.details || []}
            resourceMapping={resourceMapping}
            ticketCount={ticketCount}
            checkInCount={checkInCount}
            total_quantity={total_quantity}
            selectedAttendees={selectedAttendees}
            setSelectedAttendees={setSelectedAttendees}
            toggleSelectAttendee={toggleSelectAttendee}
            getAttendeeResponse={getAttendeeResponse}
            handleCheckIn={handleCheckIn2}
            onClose={() => setShowModal(false)}
          />
        ) : (
          <CheckInModal
            isOpen={showModal}
            config={config}
            ticketCount={ticketCount}
            checkInCount={checkInCount}
            total_quantity={total_quantity}
            incrementCheckInCount={incrementCheckInCount}
            decrementCheckInCount={decrementCheckInCount}
            handleCheckIn={handleCheckIn}
            onClose={() => setShowModal(false)}
          />
        )}
      </>
      ) : (
        <div className="flex flex-col gap-6 pb-[104px]">
          <div className="grid grid-cols-2 gap-6">
            {ATTENDEE_DETAILS.map((data) => (
              <LabelField
                key={data.key}
                title={data.label}
                text={getPrimaryDetails(data.key)}
              />
            ))}
          </div>
          <div>
            <h3 className="font-semibold mb-2">Scan History</h3>
            <div className='flex flex-col gap-4'>
              {resourceMapping?.map((resource) => resource?.is_checked_in ? (
                <div className="flex justify-start items-start gap-3 ">
                  <div className='outer-ring mt-1'>
                    <div className='inner-ring' />
                  </div>
                  <div className="items-center">
                    <div className='label-16'>Scan in</div>
                    <div className='text-14 text-grey-70'>{new Date(resource?.last_modified_date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
                  </div>
                </div>
              ) : null)}
            </div>
          </div>
          {config?.get_to_know_details?.details?.map((attendee, index) => (
            <>
              {config?.get_to_know_details?.details?.length > 1 && <div className="horizontal-divider" />}
              {config?.get_to_know_details?.details?.length > 1 && (
                <div className='flex flex-col gap-1'>
                  <div className='heading-16'>{`Attendee ${index + 1} - ${attendee?.full_name}`}</div>
                  {index === 0 && (
                    <div className='text-primary bg-light px-2 py-1 text-12 rounded w-fit'>Purchased tickets</div>
                  )}
                </div>
              )}
              <div className="grid grid-cols-2 gap-6">
                {(Object.keys(attendee || {})).map((item) => (eventQuestions?.[item]?.label && (index === 0 ? !eventQuestions?.[item]?.isPreset : true)) ? (
                  <LabelField
                    key={item}
                    title={(
                      <div className="flex gap-1">
                        {eventQuestions?.[item]?.label} &#40;
                        <div className="text-14">{eventQuestions?.[item]?.type}</div>&#41;
                      </div>)}
                    text={getAttendeeResponse(eventQuestions?.[item], item, attendee?.[item])}
                  />
                ) : null)}
              </div>
            </>
          ))}
          <div className={`absolute left-0 bottom-0 w-full flex flex-col justify-between items-center gap-2.5 px-12 py-6 
        ${!showSuccessModal ? 'bg-[#FDFDFD]' : 'bg-[#E5FFF6]'} border-t-[#F3F3F3] border-t border-solid  rounded-e-xl rounded-s-xl`}
          >
            {showSuccessModal ? (
              <div ref={modalRef} className="relative flex items-center gap-1 checkIn-bg p-4 w-[315px]">
                <CheckCircle size={24} fill="#009D64" weight="fill" />
                <h5 className="text-sm font-medium">
                  {checkInCount} ticket{checkInCount > 1 ? 's' : ''} checked in!
                </h5>
                <Button type="tertiary-text-underlined" className="ml-auto"
                  onClick={config?.get_to_know_details?.details?.length > 1 ? handleUndo2 : handleUndo}
                >
                  Undo
                </Button>
                <div className="loading-bar" />
              </div>
            ) : (
              <div className={`flex ${ticketCount > 0 ? 'justify-between' : 'justify-center'} w-full`}>
                {ticketCount > 0 &&
                  <div ref={modalRef} className="flex items-center gap-1 w-[315px]">
                    <CheckCircle size={24} fill="#009D64" weight="fill" />
                    <h5 className="text-sm font-medium">
                      {ticketCount}/{total_quantity} tickets checked in!
                    </h5>
                  </div>
                }
                <Button
                  className="checkIn-btn"
                  disabled={ticketCount >= total_quantity || !isWithinInterval(new Date(), { start: subMilliseconds(new Date(eventDetails?.start_date), TIME_INTERVAL_CONFIG.CHECKIN_START), end: addMilliseconds(new Date(eventDetails?.end_date), TIME_INTERVAL_CONFIG.CHECKIN_END) })}
                  onClick={() => setShowModal(true)}
                >
                  Check in
                </Button>
              </div>
            )}
          </div>

          {config?.get_to_know_details?.details?.length > 1 ?
            <CheckInModal2
              isOpen={showModal}
              config={config}
              eventQuestions={eventQuestions}
              attendeeDetails={config?.get_to_know_details?.details || []}
              resourceMapping={resourceMapping}
              ticketCount={ticketCount}
              checkInCount={checkInCount}
              total_quantity={total_quantity}
              selectedAttendees={selectedAttendees}
              setSelectedAttendees={setSelectedAttendees}
              toggleSelectAttendee={toggleSelectAttendee}
              getAttendeeResponse={getAttendeeResponse}
              handleCheckIn={handleCheckIn2}
              onClose={() => setShowModal(false)}
            /> :
            <CheckInModal
              isOpen={showModal}
              config={config}
              ticketCount={ticketCount}
              checkInCount={checkInCount}
              total_quantity={total_quantity}
              incrementCheckInCount={incrementCheckInCount}
              decrementCheckInCount={decrementCheckInCount}
              handleCheckIn={handleCheckIn}
              onClose={() => setShowModal(false)}
            />
          }
        </div>
      )
    );
};

export default AttendeeView;
